import script from "./ICalComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ICalComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ICalComponent.vue?vue&type=style&index=0&id=ae767234&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae767234"]])

export default __exports__